import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Typography
} from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../../constants/view-texts';
import { MuiInput } from '../../shared/form-element';

const vt = viewTexts.dialogs.editModel;

const InputWrapper = styled.div`
  padding: 5px;
`;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  modelName: string | undefined;
  modelNameErrors: string[] | undefined;
  modelNameOnInput: (v: string) => void;
  submitButtonEnabled: boolean;
  nonFieldErrors: string[];
}

export const EditModelViewDialog: FC<Props> = memo(
  ({
    open,
    onClose,
    modelName = '',
    modelNameErrors = [],
    modelNameOnInput,
    submitButtonEnabled,
    nonFieldErrors
  }: Readonly<Props>) => {
    const onCloseByEscape = useCallback(() => {
      onClose('');
    }, [onClose]);

    const cancelOnClick = useCallback(() => {
      onClose('cancel');
    }, [onClose]);

    const okOnClick = useCallback(() => {
      onClose('ok');
    }, [onClose]);

    return (
      <Dialog open={open} onClose={onCloseByEscape}>
        <DialogTitle>{vt.title}</DialogTitle>
        <DialogContent>
          <Typography>{vt.description1}</Typography>
          <Typography>{vt.description2}</Typography>
          <InputWrapper>
            <MuiInput
              label={vt.label}
              required={true}
              value={modelName}
              onInput={modelNameOnInput}
              helperText={modelNameErrors.join(' ')}
              error={modelNameErrors.length > 0}
            />
          </InputWrapper>
          {nonFieldErrors.map((er, i) => (
            <FormHelperText key={i} error={true}>
              {er}
            </FormHelperText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelOnClick} color='default'>
            {vt.cancel}
          </Button>
          <Button
            disabled={!submitButtonEnabled}
            onClick={okOnClick}
            color='primary'
            autoFocus={true}
          >
            {vt.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

EditModelViewDialog.displayName = 'EditModelViewDialog';
